export default {"src":"https://fishbrain.com/_next/static/media/ic_weather_night_365.b0b6759b.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};